import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_ALERTS: MijnRoute = {
    path: 'seintjes',
    navigationEvent: 'toAlerts',
    regex: /^\/zelf-regelen\/notificaties-beheren\/seintjes$/,
    webcomponent: 'mijn-klant-notificatie-beheer-webcomponent',
    internalPath: '/seintjes'
};
